import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";



export class AccountMenuClickAction extends BaseAction<void, string> {
    override async run(): Promise<void> {
        try {
            updateRecoilState("activeAccountActionAtom", this.params!);
            updateRecoilState("personalizeExperienceActiveTabAtom", "1");

        } catch (error) {
            console.error("Error during my account action menu click:", error);
        }
    }
}

// Create a singleton instance of the action
export const accountMenuClickAction = new AccountMenuClickAction();
